import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Spinner from '../../../common/Spinner';
import { fetchApplicantPublicProfile } from '../../../../services/operations/SettingsAPI';
import Certificates from './Certificates';
import Qualifications from './Qualifications';
import IconBtn from '../../../common/IconBtn';

const ApplicantProfile = () => {
  
  const navigate = useNavigate(); 

  const {id} = useParams();
  const {token} = useSelector(state => state.auth);
  const { user } = useSelector(state => state.profile);
  const [applicant, setApplicant] = useState({});

  useEffect(()=>{

    if(!id)
      setApplicant(user);
    else 
      setApplicantDetails(id);

  },[id]);    

  async function setApplicantDetails(id){
    const result = await fetchApplicantPublicProfile(token,id); // fetch result
    if(result){
      setApplicant(result);
    }
  }

  const handleEditProfile = ()=>{
    navigate("/dashboard/settings");
  }

  // console.log(applicant)
  if(!applicant)
      return <Spinner/>

  return (
      <div className='flex flex-col gap-10 w-11/12 text-richblack-5 max-w-[1000px] mx-auto profile'>
        <p className='text-3xl tracking-wide mb-4 font-medium'>My Profile</p>
        
        {/* Section 1 */}
        {/* <section className='flex max-xmd:flex-col flex-1 justify-between md:items-center gap-4 bg-richblack-800 p-8 sm:px-12 px-6  rounded-md border border-richblack-700'>
          <div className='flex max-xxs:flex-col flex-1 items-center gap-4'>
            profile picture
            <div className='rounded-full w-[100px] lg:w-[80px] xxs:w-[60px]'>
              <img src={user?.image} className='rounded-full object-cover aspect-square'/>
            </div>
            
            name , email
            <div className='flex flex-col gap-1'>
              <p className='font-bold text-lg max-xxs:text-center'>{user?.firstName} {" "} {user?.lastName}</p>
              <p className='text-[14px] tracking-wide text-richblack-300 max-xxs:text-center'>{user?.email}</p>
            </div>          
          </div>
          
          Edit BTN
          <IconBtn
                text={"Edit"}
                onclick={()=>{navigate('/dashboard/settings')}}
              >
                <BiLinkExternal className='text-md font-bold'/>
          </IconBtn>
        
        </section> */}

        {/* Section 2 */}
        <section className='flex flex-col justify-between gap-10 bg-richblack-800 p-8 sm:px-12 px-6 rounded-md border border-richblack-700'>
            <div className='flex justify-between items-center'>
              <p className='text-lg font-bold'>About</p>
              <IconBtn
                text={"Edit"}
                type={"button"}
                onclick={()=>{handleEditProfile()}}
              />
            </div>
            <p className='w-[90%]'>
              {
                applicant?.description != null 
                ? <span>{applicant?.description}</span>
                : <span className='text-richblack-300 text-[14px] tracking-wide'>
                  Write Something About Yourself
                </span>
              }
            </p>
        </section>

        {/* Section 3 */}
        <section className='flex flex-col justify-between gap-10 bg-richblack-800 p-8 sm:px-12 px-6 rounded-md border border-richblack-700'>
  
          {/* Heading and Edit BTN */}
          <div className='flex justify-between items-center'>
            <p className='text-lg font-bold'>Personal Details</p>
            {/* <IconBtn
                text={"Edit"}
                onclick={()=>{navigate('/dashboard/settings')}}
              >
                <BiLinkExternal className='text-md font-bold'/>
            </IconBtn> */}
          </div>
          
          {/* Details */}
          <div className='flex flex-col gap-5 max-w-[500px] text-[15px]'>

            <div className=' w-full flex max-xxxs:flex-col gap-4 xxxs:items-center justify-between'>
              <label className='flex flex-col gap-2 xxxs:w-[30%]'>
                <p className='text-sm text-richblack-600'>First Name</p>
                <p>{applicant?.firstName}</p>
              </label>
              
              <label className='flex flex-col gap-2 xxxs:w-[30%]'>
                <p className='text-sm text-richblack-600'>Last Name</p>
                <p>{applicant?.lastName}</p>
              </label>
            </div>
           
            <div className=' w-full flex max-xmd:flex-col gap-4 xmd:items-center justify-between'>
              <label className='flex flex-col gap-2 xmd:w-[30%]'>
                <p className='text-sm text-richblack-600'>Email</p>
                <p>{applicant?.email}</p>
              </label>
              
              <label className='flex flex-col gap-2 xmd:w-[30%]'>
                <p className='text-sm text-richblack-600'>Phone Number</p>
                <p>
                  {
                    applicant && applicant?.mobile
                    ? applicant?.mobile
                    : "Add Contact Number" 
                  }
                </p>
              </label>
            </div>
            
            <div className='w-full flex max-xmd:flex-col gap-4 xmd:items-center justify-between'>
              <label className='flex flex-col gap-2 xmd:w-[30%]'>
                <p className='text-sm text-richblack-600'>Gender</p>
                <p>
                  {
                    applicant && applicant?.gender 
                    ? applicant?.gender
                    : "Add Gender"
                  }
                </p>
              </label>
              
              <label className='flex flex-col gap-2 xmd:w-[30%]'>
                <p className='text-sm text-richblack-600'>Date Of Birth</p>
                <p>
                  {
                    applicant && applicant?.dob
                    ? applicant?.dob
                    : "January 1,1970" 
                  }
                </p>
              </label>
            </div>
          </div>
  
        </section>

        {/* Section 4 */}
        <section className='flex flex-col justify-between gap-6 bg-richblack-800 p-8 sm:px-12 px-6 rounded-md border border-richblack-700'>
  
          {/* Heading and Edit BTN */}
          <div className='flex justify-between items-center'>
            <p className='text-xl font-bold'>Qualifications</p>
            {/* <IconBtn
                text={"Edit"}
                onclick={()=>{navigate('/dashboard/settings')}}
              >
                <BiLinkExternal className='text-md font-bold'/>
            </IconBtn> */}
          </div>
          
          {/* Details */}
          <div className='flex flex-col justify-between gap-5 bg-richblack-900 p-4 lg:p-6 rounded-md border border-richblack-500 lg:max-w-[90%]'>
              {
                applicant?.education && applicant?.education?.length 
                ? applicant?.education?.map((ed,index) => (
                  <Qualifications key={index} education={ed}/>
                ))
                : <p>No Qualifications Yet</p>
              }
          </div>
        </section>

        {/* Section 4 */}
        <section className='flex flex-col justify-between gap-6 bg-richblack-800 p-8 sm:px-12 px-6 rounded-md border border-richblack-700'>
          
          {/* Heading and Edit BTN */}
          <div className='flex justify-between items-center'>
            <p className='text-xl font-bold'>Skills</p>
          </div>
          
          {/* Details */}
          <div className='flex flex-col justify-center gap-5 bg-richblack-900 p-4 lg:p-6 rounded-md border border-richblack-500 lg:max-w-[90%]'>
              {
                applicant?.skills && applicant?.skills?.length 
                ? applicant?.skills?.map((sk,index) => (
                  <span className='text-richblack-5 px-4 py-1 bg-yellow-400 w-fit rounded-3xl font-medium' key={index}>
                    {sk}
                  </span>
                ))
                : <span>No Qualifications Yet</span>
              }
          </div>
        </section>

        {/* Section 5 */}
        <section className='flex flex-col justify-between gap-6 bg-richblack-800 p-8 sm:px-12 px-6 rounded-md border border-richblack-700'>
  
          {/* Heading and Edit BTN */}
          <div className='flex justify-between items-center'>
            <p className='text-xl font-bold'>Certifications</p>
            {/* <IconBtn
                text={"Edit"}
                onclick={()=>{navigate('/dashboard/settings')}}
              >
                <BiLinkExternal className='text-md font-bold'/>
            </IconBtn> */}
          </div>
          
          {/* Details */}
          <div className='flex flex-col justify-between gap-5 bg-richblack-900 p-4 lg:p-6 rounded-md border border-richblack-500 lg:max-w-[90%]'>
              {
                applicant?.certification && applicant?.certification?.length 
                ? applicant?.certification?.map((ct,index) => (
                  <Certificates key={index} certificate={ct}/>
                ))
                : <p>No Certifications yet</p>
              }
          </div>
        </section>
        
        {/* Section 6 */}
        <section className='flex flex-col justify-center gap-6 bg-richblack-800 p-8 sm:px-12 px-6 rounded-md border border-richblack-700'>
  
          {/* Heading and Edit BTN */}
          {/* <div className='flex justify-between items-center'>
            <p className='text-xl font-bold'>Social Links</p>
          </div> */}
          
          {/* Details */}
          <div className='flex items-baseline gap-x-3 flex-grow'>
            <p className='px-3 py-2 rounded-sm bg-[#FF0000] bg-opacity-80 font-bold text-richblack-5 text-sm flex-wrap hover:opacity-80 duration-100'>
                <a target="_blank" href={user?.resume}>Resume</a>
            </p>
            <p className='px-3 py-2 rounded-sm bg-[#0072b1] bg-opacity-80 font-bold text-richblack-5 text-sm hover:opacity-80 duration-100'>
                <a target="_blank" href={user?.linkedIn}>LinkedIn</a>
            </p>
              {
                  user?.portfolio &&
                  <p className='px-3 py-2 rounded-sm bg-caribbeangreen-200 bg-opacity-80 font-bold text-richblack-5 text-sm hover:opacity-80 duration-100'>
                      <a target="_blank" href={user?.portfolio}>Portfolio</a>
                  </p>
              }
          </div>
        </section>

      </div>
  )
}

export default ApplicantProfile;